export const getDataURIMimeType = (dataUrl) => {
	if (!dataUrl) return undefined;
	return dataUrl.substring(dataUrl.indexOf(":") + 1, dataUrl.indexOf(";"));
};

export const mimeTypes = {
	pdf: "application/pdf",
	png: "image/png",
	jpg: "image/jpg",
	jpeg: "image/jpeg",
};
